<template>
  <ion-card>
    <ion-card-content>
      <p>Update the e-mail address used for owner user recovery</p>
      <ion-row>
        <ion-col size-md="6">
          <ion-input-vue
            v-model="recoveryEmail"
            type="email"
            placeholder="Recovery e-mail address"
            :disabled="busy"
            required
          />
        </ion-col>
      </ion-row>
    </ion-card-content>
    <ion-card-footer>
      <ion-button
        expand="full"
        :disabled="busy"
        @click="save"
      >
        <ion-spinner v-if="busy" />
        Update
      </ion-button>
    </ion-card-footer>
  </ion-card>
</template>

<script>
import { IonInputVue, modalController } from '@modus/ionic-vue'
import router from '../../router'
import store from '../../state'

export default {
  components: {
    IonInputVue
  },
  props: {
    serialNumber: {
      type: String,
      required: true
    },
    currentRecoveryEmail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      busy: false,
      recoveryEmail: this.currentRecoveryEmail,
    }
  },
  methods: {
    async save() {
      const serialNumber = router.currentRoute.params.serialNumber

      this.busy = true

      try{
        await store.dispatch('changeRecoveryEmail', {
          serialNumber,
          emailAddress: this.recoveryEmail
        })
        await store.dispatch('fetchBridgeSettings', { serialNumber: this.serialNumber })
        return modalController.dismiss()
      } catch(e){
        // inore
      }
      this.busy = false
    },
  },
}
</script>

<style scoped>
ion-card {
  margin:0;
}
</style>

<style>
.pin-to-version-modal .modal-wrapper {
  background:none;
}
</style>
